import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { MainNavProps, MediaPreviewSchema } from './navigation/main/MainParamList';
import { black } from '../assets/style/colors';
import { ImagePreviewModal, PreviewItem } from '../components/ImagePreviewModal';

type MediaPreviewNavProps = MainNavProps<'MediaPreviewScreen'>;

export function MediaPreviewScreen({ navigation, route }: MediaPreviewNavProps) {
	const { items, initialIndex = 0 } = route.params;

	// 将 MediaPreviewSchema 转换为 PreviewItem 类型
	const previewItems = useMemo(() => {
		return items.map((item: MediaPreviewSchema) => ({
			mid: item.mid,
			type: item.type,
			content: item.content,
			thumbnailPath: item.thumbnailPath,
			upload_path: item.upload_path,
			path: item.upload_path,
			// 保留其他可能需要的属性
			tid: 'tid' in item ? (item as any).tid : undefined,
			sid: 'sid' in item ? (item as any).sid : undefined,
			tmid: 'tmid' in item ? (item as any).tmid : undefined,
			uid: 'uid' in item ? (item as any).uid : undefined,
			cid: 'cid' in item ? (item as any).cid : undefined,
			sender: 'sender' in item ? (item as any).sender : undefined,
			stime: 'stime' in item ? (item as any).stime : undefined,
			meta: 'meta' in item ? (item as any).meta : undefined,
		}));
	}, [items]);

	// 关闭预览并返回上一页
	const handleClose = () => {
		navigation.goBack();
	};

	return (
		<View style={styles.container}>
			<ImagePreviewModal
				visible={true}
				items={previewItems as PreviewItem[]}
				initialIndex={initialIndex}
				onClose={handleClose}
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: black,
	},
	page: {
		width: '100%',
		height: '100%',
	},
	scrollView: {
		flex: 1,
	},
	contentContainer: {
		padding: 16,
		paddingBottom: 32, // 添加底部内边距
	},
	emojiTextView: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		padding: 12,
	},
});
